import { Component, Input } from '@angular/core';
import { Platform } from '../../models/api';
import { EffectivePolicySettingEnum } from '../../services/infra/store/model/effectivePolicySetting.model';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-privileged-identities-section',
  templateUrl: './privileged-identities-section.component.html',
  styleUrls: ['./privileged-identities-section.component.scss'],
})
export class PrivilegedIdentitiesSectionComponent {
  public title: string;
  public description: string;
  protected effectivePolicySetting: EffectivePolicySettingEnum;
  public formControlName: string;

  @Input() value!: number;
  @Input() editable!: boolean;
  @Input() platform!: Platform;
  @Input() settingsFormGroup!: UntypedFormGroup;
}
